import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { InputText } from "primereact/inputtext";
import updateIconImg from "../../Assets/updateIconImg.png";
import deleteIconImg from "../../Assets/deleteIcon.png";
import addIcon from "../../Assets/addWhiteIcon.png";
import { Dropdown } from "primereact/dropdown";
import { useDispatch, useSelector } from "react-redux";
import {
  getIecData,
  getSelectedItems,
} from "../../Store/IECModule/IECModuleSelector";
import IECVideoModal from "./IECVideoModal";
import { useNavigate } from "react-router";
import { Tooltip } from "primereact/tooltip";
import "./IECVideoModal.scss";
import IECDeleteModal from "./IECDeleteModal";
import AddIECModule from "./AddIECModule";
import UpdateIECModule from "./UpdateIECModule";
import {
  fetchIECViewData,
  selectIECItems,
} from "../../Store/IECModule/IECModuleAction";
import { useTranslation } from "react-i18next";
import Excalmation from "../../Assets/Exclamation.png";
import { useLanguage } from "../ChangeLanguage/LanguageProvider";
import UserRoles from "../../Shared/Constant/UserRoles";

function getUniqueValuesByKey(data, key) {
  const values = data.map((data) => data[key]);
  return [...new Set(values)];
}
const CategoryHeaderTemplate = () => {
  const { t } = useTranslation("Iec");
  return (
    <div
      style={{ whiteSpace: "normal", textAlign: "center", lineHeight: "1.2" }}
    >
      {t("CategoryTypeofVideo")}
    </div>
  );
};

function IECModuleView() {
  const { t } = useTranslation("Iec");
  const [dataitem, setDataitem] = useState([]);
  const [categoryType, setCategoryType] = useState([]);
  const [audience, setAudience] = useState([]);
  const [uploadedDateTime, setUploadedDateTime] = useState([]);
  const [updateDisable, setUpdateDisable] = useState(true);
  const selectedItems = useSelector(getSelectedItems);
  const [filter] = useState(false);
  const role = sessionStorage.getItem("userRole");
  const fetchedData = useSelector(getIecData);
  const dispatch = useDispatch();
  const { selectedLanguageId } = useLanguage();
  useEffect(() => {
    const updateDataItem = (data) => {
      if (role === UserRoles.ADMIN || role === UserRoles.SUPERADMIN) {
        setDataitem(data);
      } else {
        setDataitem(data.filter((row) => row.validStatus === "Valid"));
      }
    };
    updateDataItem(fetchedData);
  }, [fetchedData, role]);

  useEffect(() => {
    fetchIECViewData(dispatch, selectedLanguageId)();
  }, [dispatch, selectedLanguageId]);

  useEffect(() => {
    setUpdateDisable(selectedItems.length === 0);
  }, [selectedItems]);

  useEffect(() => {
    const fetchedCategoryType = getUniqueValuesByKey(dataitem, "categoryType");
    const fetchedAudience = getUniqueValuesByKey(dataitem, "audience");
    const fetchedUploadedDateTime = getUniqueValuesByKey(
      dataitem,
      "uploadedDateTime"
    );
    setCategoryType(fetchedCategoryType);
    setAudience(fetchedAudience);
    setUploadedDateTime(fetchedUploadedDateTime);
  }, [dataitem]);
  const handleSelectionChange = (e) => {
    dispatch(selectIECItems(e.value)); // Dispatch action to select items
  };
  const audienceLabels = {
    ASHA: "ASHA",
    ANM: "ANM",
    mother: "Mother",
    block: "Block Facilitator",
  };

  const dropdownFilters = (options) => {
    let optionVals = [];
    switch (options.field) {
      case "categoryType":
        optionVals = categoryType;
        break;
      case "audience":
        optionVals = Array.isArray(audience)
          ? audience
              .flat()
              .filter((value, index, self) => self.indexOf(value) === index)
              .map((audienceItem) => ({
                label: audienceLabels[audienceItem] || audienceItem,
                value: audienceItem,
              }))
          : [];
        break;
      case "uploadedDateTime":
        optionVals = uploadedDateTime.filter((date) => date !== null);
        break;
      case "validStatus":
        optionVals = ["Valid", "Invalid"];
        break;

      default:
    }
    return (
      <Dropdown
        value={options.value}
        options={optionVals}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder={t("Select")}
        showClear
        className="cockpit-filter-dropdown"
      />
    );
  };

  const searchTemplate = (options) => {
    return (
      <div className="p-input-icon-right">
        <i className="pi pi-search cockpit-custom-search-icon" />
        <InputText
          type="text"
          value={options.value}
          onChange={(e) => options.filterApplyCallback(e.target.value)}
          placeholder={t("Search")}
          className="p-column-filter"
        />
      </div>
    );
  };

  const navigate = useNavigate();
  const selectedIds = selectedItems.map((item) => item.id);
  const getBorderClassName = () => {
    if (role === UserRoles.ADMIN) {
      return "border-fifth";
    } else if (role === UserRoles.SUPERADMIN) {
      return "border-fourth";
    } else {
      return "border-second";
    }
  };
  const renderTooltipComponent = (rowData) => (
    <>
      {" "}
      {rowData.validStatus !== "Valid" && rowData.remarks ? (
        <>
          <Tooltip
            target={`#tooltip_${rowData.id}`}
            mouseTrack
            mouseTrackLeft={2}
            mouseTrackTop={2}
          >
            <div className="demo-video" />
            <div
              style={{
                maxWidth: "281px",
                backgroundColor: "#fff",
                padding: "5px",
                color: "black",
              }}
            >
              <p
                style={{
                  color: "#E03581",
                  margin: 0,
                  fontWeight: "700",
                }}
              >
                {rowData.remarks}
              </p>
            </div>
          </Tooltip>
          <span id={`tooltip_${rowData.id}`} data-testid="Exclamation">
            <img
              id={`tooltip_${rowData.id}`}
              src={Excalmation}
              alt="Exclamation"
            />
          </span>
        </>
      ) : null}{" "}
    </>
  );
  const renderVideoTitle = (rowData) => (
    <div
      style={{ minWidth: "180px", color: "#2C3D8F" }}
      onClick={() => {
        navigate(`/iecmodule?preview=${rowData.id}`);
      }}
    >
      {selectedLanguageId === 1
        ? rowData.videoTitle.english
        : rowData.videoTitle.marathi}
    </div>
  );
  const validStatusFunction = (rowData) => (
    <span
      style={{
        color: rowData.validStatus === "Valid" ? "green" : "red",
        fontFamily: "Open Sans, sans-serif",
        fontWeight: 600,
        fontSize: "10px",
        marginLeft: "10px",
      }}
    >
      {rowData.validStatus}
    </span>
  );
  const audienceFunction = (rowData) => {
    const audienceMap = {
      ASHA: "ASHA",
      ANM: "ANM",
      mother: "Mother",
      block: "Block Facilitator",
    };
    let audienceLabel = "";
    if (Array.isArray(rowData.audience)) {
      audienceLabel = rowData.audience
        .map((audienceItem) => audienceMap[audienceItem] || audienceItem)
        .join(", ");
    } else {
      audienceLabel = audienceMap[rowData.audience] || rowData.audience;
    }
    return (
      <span style={{ maxWidth: "100px", whiteSpace: "normal" }}>
        {audienceLabel}
      </span>
    );
  };
  const videoDescriptionFunction = (rowData) => (
    <div
      style={{
        whiteSpace: "normal",
        width: "270px",
        maxHeight: "50px",
      }}
    >
      <Tooltip
        target={`#tooltip_description_${rowData.id}`}
        mouseTrack
        mouseTrackLeft={2}
        mouseTrackTop={2}
      >
        <div className="demo-video" />
        <div
          style={{
            maxWidth: "281px",
            padding: "5px",
            color: "black",
            backgroundColor: "white",
          }}
        >
          <p style={{ color: "#E03581", margin: 0, fontWeight: "700" }}>
            Video Description
          </p>
          {rowData.videoDescription}
        </div>
      </Tooltip>
      <span id={`tooltip_description_${rowData.id}`}>
        {rowData.videoDescription}
      </span>
    </div>
  );
  return (
    <>
      <div className="">
        {/* masterScreen */}
        <div className="grid flex justify-content-end mb-2">
          <div className=" md:col-6 col-div"></div>
          <div className="sm:col-12 md:col-6 button_section">
            <div className="grid align-items-center justify-content-end">
              {!(
                role === UserRoles.PHCHEAD ||
                role === UserRoles.DISTRICTHEAD ||
                role === UserRoles.STATEHEAD ||
                role === UserRoles.BLOCKHEAD
              ) ? (
                <>
                  <div className="flex sm:col-12 sm:text-center justify-content-end align-items-center md:col pr-0">
                    <Button
                      className="master-updateBtn"
                      label={t("Update")}
                      severity="info"
                      icon={<img src={updateIconImg} alt="Update icon" />}
                      outlined
                      disabled={updateDisable}
                      tooltip="Update Video Module"
                      tooltipOptions={{ position: "bottom", event: "both" }}
                      onClick={() => {
                        if (selectedItems && selectedItems.length === 1) {
                          navigate(`/iecmodule?update=${selectedItems[0].id}`);
                        }
                      }}
                    />

                    <Button
                      className="master-deleteBtn"
                      label={t("Delete")}
                      severity="danger"
                      icon={<img src={deleteIconImg} alt="Delete icon" />}
                      outlined
                      disabled={
                        selectedItems.length === 0 || selectedItems.length > 1
                      }
                      tooltip="Delete Video Module"
                      tooltipOptions={{ position: "bottom", event: "both" }}
                      onClick={() => {
                        if (selectedItems && selectedItems.length === 1) {
                          navigate(`/iecmodule?delete=${selectedItems[0].id}`);
                        }
                      }}
                    />
                  </div>

                  <div className="divider-layout">
                    <Divider layout="vertical" />
                  </div>
                  <div className="flex sm:col-12 w-auto sm:text-center md:col-5">
                    <Button
                      className="addBtn"
                      label={t("AddNewVideoModule")}
                      icon={<img src={addIcon} alt="Add icon" />}
                      disabled={selectedItems.length > 0}
                      tooltip="Add New Video Module"
                      tooltipOptions={{ position: "bottom", event: "both" }}
                      onClick={() => {
                        navigate("/iecmodule?tab=add");
                      }}
                    />
                  </div>
                </>
              ) : null}
            </div>
          </div>
        </div>

        <DataTable
          className="table-viewport custom-tooltip"
          resizableColumns
          selectionMode={"checkbox"}
          value={dataitem}
          size="small"
          dataKey="videoTitle"
          emptyMessage="No data found."
          filterDisplay="row"
          selection={selectedItems}
          onSelectionChange={handleSelectionChange}
          scrollable
          scrollHeight="510px"
        >
          {(role === UserRoles.ADMIN || role === UserRoles.SUPERADMIN) && (
            <Column
              selectionMode="multiple"
              header={t("Select")}
              frozen
              alignFrozen="left"
            ></Column>
          )}

          {role === UserRoles.ADMIN && (
            <Column
              frozen={true}
              alignFrozen="left"
              body={(rowData) => renderTooltipComponent(rowData)}
            />
          )}

          <Column
            frozen={true}
            alignFrozen="left"
            field="videoTitle"
            header={t("VideoTitle")}
            filter
            showFilterMenu={false}
            filterPlaceholder={t("Search")}
            filterElement={searchTemplate}
            body={(rowData) => renderVideoTitle(rowData)}
            style={{ cursor: "pointer" }}
          />
          {(role === "Admin" || role === "Support Admin") && (
            <Column
              frozen={true}
              alignFrozen="left"
              field="validStatus"
              header={t("Status")}
              body={(rowData) => validStatusFunction(rowData)}
              filter
              showFilterMenu={false}
              filterPlaceholder={t("Select")}
              filterElement={dropdownFilters}
            />
          )}
          <Column
            frozen={true}
            headerStyle={{
              borderRight: "3px solid #d9d9d9",
              position: "sticky",
            }}
            bodyStyle={{ borderRight: "3px solid #d9d9d9", position: "sticky" }}
            alignFrozen="left"
            className={getBorderClassName()}
          />
          <Column
            frozen={false}
            field="categoryType"
            filter
            showFilterMenu={false}
            filterPlaceholder={t("Select")}
            filterElement={dropdownFilters}
            header={CategoryHeaderTemplate}
          />
          <Column
            frozen={false}
            field="audience"
            header={t("Audience")}
            body={(rowData) => audienceFunction(rowData)}
            filter
            showFilterMenu={false}
            filterPlaceholder={t("Select")}
            filterElement={dropdownFilters}
          />

          <Column
            field="videoDescription"
            header={t("VideoDescription")}
            body={(rowData) => videoDescriptionFunction(rowData)}
            style={{ cursor: "pointer" }}
          />
          {(role === UserRoles.ADMIN || role === UserRoles.SUPERADMIN) && (
            <Column
              field="uploadedBy"
              header={
                role === UserRoles.SUPERADMIN
                  ? t("ModifiedBy")
                  : t("ApprovedBy")
              }
              filter
              showFilterMenu={false}
              filterPlaceholder={t("Search")}
              filterElement={searchTemplate}
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "126px",
              }}
            />
          )}
          {(role === UserRoles.ADMIN || role === UserRoles.SUPERADMIN) && (
            <Column
              field="uploadedDateTime"
              header={
                role === "Support Admin"
                  ? t("ModifiedDate&Time")
                  : t("ApprovedDate&Time")
              }
              filter
              showFilterMenu={filter}
              filterElement={searchTemplate}
              body={(dateObject) => dateObject.uploadedDateTime}
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
          )}
        </DataTable>
        <p className="text-sm">
          {" "}
          {dataitem.length} {t("Totalrecord")}{" "}
        </p>
      </div>
      <IECVideoModal />
      <IECDeleteModal />
      <AddIECModule />
      <UpdateIECModule iecId={selectedIds} />
    </>
  );
}

export default IECModuleView;
